// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-zNILj";
var _3 = "header-2Ss1s";
var _4 = "disabled-2cLVx";
var _5 = "content-VJciQ";
var _6 = "header__title-gw5Hc";
var _7 = "header__price-9oF47";
var _8 = "header__icon-2TfQy";
var _9 = "header__number-lNbLu";
export { _1 as "__esModule", _2 as "wrapper", _3 as "header", _4 as "disabled", _5 as "content", _6 as "header__title", _7 as "header__price", _8 as "header__icon", _9 as "header__number" }
export default { "__esModule": _1, "wrapper": _2, "header": _3, "disabled": _4, "content": _5, "header__title": _6, "header__price": _7, "header__icon": _8, "header__number": _9 }
